import { Routes } from "@angular/router";
import { UserListComponent } from "./user-list/user-list.component";
import { UserCreatedComponent } from "./user-created/user-created.component";
import { UserDetailedComponent } from "./user-detailed/user-detailed.component";
import { UserEditComponent } from "./user-edit/user-edit.component";
import { actionsGuard } from "../shared/guards/actions.guard";
import { UserDeleteComponent } from "./user-delete/user-delete.component";

export const userRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: UserListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: UserCreatedComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: UserEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: UserDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: UserDetailedComponent, canActivate: [actionsGuard] },
]
